var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.623 20.631 43.65 2h-3.798L25.936 18.177 14.82 2H2l16.809 24.463L2 46h3.798l14.697-17.083L32.234 46h12.82L27.622 20.631m-5.202 6.047-1.703-2.436L7.167 4.86H13l10.935 15.643 1.704 2.436L39.854 43.27H34.02z"
  })));
};
export default SvgX;